import { Paper } from "@mui/material";
import i18next from "i18next";
import EAButton from "./common/EAButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { theme } from "style/globalStyle";
import EAColorIcon from "./common/EAColorIcon";

const HasNotPrivilegePage = () => {
    const history = useHistory();

    const goToHomePageHandler = () => {
        history.push("/");
    }

    return(
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: "450px"
        }}>
            <Paper elevation={1} style={{
                padding: "62px 24px 40px 24px", 
                maxWidth: "600px",
                position: 'relative',
                display: "flex", 
                flexDirection : "column", 
                alignItems: 'center',
                gap: "16px"}}
                >
                <div style={{color: theme.palette.grey.grey700, fontWeight: '600', fontSize:"22px"}}>
                    {i18next.t("notAuthorized.notAuthorizedTitle")}
                </div>
                <div style={{color: theme.palette.grey.grey700, fontWeight: '400'}}>{i18next.t("notAuthorized.notAuthorizedDescription")}</div>
                <EAButton onClick={goToHomePageHandler} content={i18next.t("notAuthorized.notAuthorizedAction")}/>

                <EAColorIcon icon="info-rounded" height="80px" width="80px" color={theme.palette.grey.grey100}  
                    svgStyle={{position: "absolute", top: "-30px"}}/>
            </Paper>
        </div>
    )

}

export default HasNotPrivilegePage;

